import React from "react";
import LandingHero from "./LandingHero";
import LandingAgentValue from "./LandingAgentValue";
import LandingProductShowcase from "./LandingProductShowcase";
import LandingBenefits from "./LandingBenefits";
import LandingBusiness from "./LandingBusiness";
import LandingAudience from "./LandingAudience";
import LandingTrust from "./LandingTrust";
import LandingSteps from "./LandingSteps";
import LandingFaq from "./LandingFaq";
import LandingBottomCta from "./LandingBottomCta";
import LandingStickyCta from "./LandingStickyCta";

import "./LandingHomePage.scss";

export default function LandingHomePage() {
  return (
    <div className="hr-landing">
      <LandingHero />
      <LandingAgentValue />
      <LandingProductShowcase />
      <LandingBenefits />
      <LandingBusiness />
      <LandingAudience />
      <LandingTrust />
      <LandingSteps />
      <LandingFaq />
      <LandingBottomCta />
      <LandingStickyCta />
    </div>
  );
}
